import PaginationChangeEvent from '@adobe-fonts/site/events/PaginationChangeEvent.js';

import { get } from '../util/secure_fetch.js';

import PostLoginActionProcessor from '../util/post_login_actions/post_login_action_processor.js';

import { registerEventHandlers as registerFamilyCardProjectHandlers } from './mixins/FamilyCardAddToWebProject.js';
import { registerEventHandlers as registerFamilyCardFavoriteHandlers } from './mixins/FamilyCardFavorite.js';
import { registerEventHandlers as registerFamilyCardSyncHandlers } from './mixins/FamilyCardSync.js';
import { registerEventHandlers as registerFamilyCardImagesToggle } from './mixins/ImagesToggle.js';
import { registerEventHandlers as registerSaveToLibraryHandlers } from './mixins/SaveToLibrary.js';
import { updatePageUrl, sendAnalytics } from './mixins/Pagination.js';

import { registerEventHandlers as registerCoachmarkHandlers } from '../util/coachmark_helpers.js';

const PAGE = 'font-discovery-results';

/**
 * A wrapper element for the search results page.
 *
 * This component doesn't render its own DOM, but
 * sets up event listeners for the search results page.
 */
class SearchResults extends HTMLElement {
  connectedCallback() {
    registerCoachmarkHandlers();
    registerFamilyCardFavoriteHandlers(this);
    registerFamilyCardProjectHandlers(this);
    registerFamilyCardSyncHandlers(this);
    registerFamilyCardImagesToggle(this);
    registerSaveToLibraryHandlers(this);

    this.addEventListener(PaginationChangeEvent.EVENT_NAME, this.handleFontsPageChange);
    window.addEventListener('load', this.handlePageLoad);
  }

  disconnectedCallback() {
    this.removeEventListener(PaginationChangeEvent.EVENT_NAME, this.handleFontsPageChange);
    window.removeEventListener('load', this.handlePageLoad);
  }

  get _fontsListContainer() {
    return this.querySelector('#fonts-list');
  }

  get _paginationContainer() {
    return this.querySelector('#discovery-pagination-container');
  }

  async handleFontsPageChange(event: Event) {
    try {
      const params = new URLSearchParams(window.location.search);
      const currentPage = (event as PaginationChangeEvent).detail.page;
      const query = params.get('query');

      const response = await get(`/search/fonts.json?page=${currentPage}&query=${query}`);
      const data = await response.json();

      const fontCards = new DOMParser().parseFromString(data.content.fontCards, 'text/html');
      const pagination = new DOMParser().parseFromString(data.content.paginationComponent, 'text/html');
      this._fontsListContainer?.replaceChildren(...fontCards.body.children);
      this._paginationContainer?.replaceChildren(...pagination.body.children);

      updatePageUrl(currentPage);
      sendAnalytics(PAGE, event);
    } catch (error) {
      console.log('Fonts page change error', error);
    }
  }

  handlePageLoad() {
    PostLoginActionProcessor.handlePageLoad();
  }
}

customElements.define('af-search-results', SearchResults);
